import { render, staticRenderFns } from "./EmployeeResources.vue?vue&type=template&id=5f37457b&scoped=true"
import script from "./EmployeeResources.vue?vue&type=script&lang=js"
export * from "./EmployeeResources.vue?vue&type=script&lang=js"
import style0 from "./EmployeeResources.vue?vue&type=style&index=0&id=5f37457b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f37457b",
  null
  
)

export default component.exports